var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg09BmwSpeedometer5YcElectric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    height: "356px",
    width: "290px",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("line", {
    id: "baseline-1_1_",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilterOo",
    filterUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_9-5y-mask",
    filter: "url(#Adobe_OpacityMaskFilterOo)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 22,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y_1_",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M73,250h9v77h-9V250z M108,327h9v-77h-9V327z M143,327h9v-77h-9V327z M178,327h9v-77h-9V327z M73,247h9V76h-9 V247z M108,247h9V76h-9V247z M143,247h9V76h-9V247z M178,76v171h9V76H178z M60,327h9V76h-9V327z M95,327h9V76h-9V327z M130,327h9 V76h-9V327z M165,327h9V76h-9V327z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y",
    fill: "#3C6BAD",
    d: "M213,250h9v77h-9V250z M213,76v171h9V76H213z M200,327h9V76h-9V327z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "plug-pin",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "221.5,250.5 227,239.5 290,239.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "electric-pin_1_",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "221.5,77 227,66 290,66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "total-pin",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "208.5,77 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "head-rolls-royce",
    transform: "matrix(1 0 0 1 11.0835 317.7383)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Plug-in Hybride"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.909,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Einheiten")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-plug",
    transform: "matrix(1 0 0 1 282.0972 235.5)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-electric",
    transform: "matrix(1 0 0 1 282.0972 61.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    id: "head-bmw",
    transform: "matrix(1 0 0 1 13.3633 199.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Vollelektrische"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.859,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Fahrzeuge"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.629,
    y: 16.8,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Einheiten")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-total",
    transform: "matrix(1 0 0 1 282.0972 31.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    id: "head-total",
    transform: "matrix(1 0 0 1 17.229 81.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Elektrifizierte"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.694,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Fahrzeuge "), /*#__PURE__*/React.createElement("tspan", {
    x: 3.763,
    y: 16.8,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Einheiten")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09BmwSpeedometer5YcElectric);
export default __webpack_public_path__ + "static/media/09_BMW_speedometer-5YC-electric.919e0a73.svg";
export { ForwardRef as ReactComponent };